import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";

import { 
    fetchLang,
    fetchLangMenu,
    fetchLangDateFilter,
    fetchLangFullMonth,
    fetchLangShortMonth,
    fetchLangMaster,
    fetchLangDashboard,
    fetchLangCustomer,
    fetchLangCustomerFocus,
} from '../actions';

const LanguageProvider = ({children}) => {
    const dispatch = useDispatch();

    const { languageSelected } = useSelector(({settings})=>settings);
    const { authUser } = useSelector(({auth}) => auth);

    //Set Language
    useEffect(() => {
        //Check Auth
        if(authUser){
            let params = {
                company: authUser ? authUser.company : "",
                language: languageSelected ? languageSelected.id : "",
            };

            //Language
            dispatch(fetchLang(params));

            //Language Menu
            dispatch(fetchLangMenu(params));

            //Language Date Filter
            dispatch(fetchLangDateFilter(params));

            //Language Full Month
            dispatch(fetchLangFullMonth(params));

            //Language Short Month
            dispatch(fetchLangShortMonth(params));

            //Language Master
            dispatch(fetchLangMaster(params));

            //Language Dashboard
            dispatch(fetchLangDashboard(params));

            //Language Customer
            dispatch(fetchLangCustomer(params));

            //Language Customer Focus
            dispatch(fetchLangCustomerFocus(params));
        }
        
    }, [dispatch, authUser, languageSelected]);

    return(
        <>
        {children}
        </>
    )
}

export default LanguageProvider;